import React from "react";
import Scan from "../components/scan";

const Home = () => {
  return (
    <div className="flex flex-col flex-1 max-h-full rounded-md container mx-auto">
      <div className="p-4 text-white bg-blue-500">
        <div className="flex items-center justify-center">
          <span className="text-3xl font-semibold tracking-wider uppercase">Asset Tracking</span>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 my-4 mt-4">
        <div className="flex items-center justify-center w-full h-full bg-white">
          <Scan scanRate={250} />
        </div>
      </div>
    </div>
  );
};

export default Home;
